export default {
  title: {
    id: 'product_page_customization_keyboard_modal_title',
    defaultMessage: 'Keyboard layout options',
  },
}
